// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.style-about-salon[data-v-7e13a6ba] {\n  margin: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
